import { headers, baseUrl } from "../../common/credentials";

const sourcePort = "1200";
const reconPort = "1200";
const etlPort = "1200";
const Port = "1200";

export const getProcessingLayerListFromServer = () => {
    let url = baseUrl +  "/api/v2/user_modules/get_processing_layer_list/";
    return ([headers, url]);
} 


export const sendMail = () => {
    let url = baseUrl +  "/api/v2/user_modules/sendmail/";
    return ([headers, url]);
} 

export const servePdf = () => {
    let url = baseUrl +  "/api/v2/user_modules/serve_pdf/";
    return ([headers, url]);
} 


export const Fetchupload = () => {
    let url = baseUrl +  "/api/v2/user_modules/upload/";
    return ([headers, url]);
}

export const Fetchheaderdata = () => {
    let url = baseUrl +  "/api/v2/user_modules/getheadersdata/";
    return ([headers, url]);
}

export const getProcessingLayerListFromServer1 = () => {
    let url = baseUrl +  "/api/v2/user_modules/get_all_data/Vendor_Reconcilation_System/vendor_master/";
    return ([headers, url]);
} 

export const getProcessingLayerDataFromServer = () => {
    let url = baseUrl +  "/recon/get_processing_layer_data/";
    return ([headers, url]);
} 

export const getProcessingLayerDataReturnFromServer = () => {
    let url = baseUrl +  "/recon/get_processing_layer_data_return/";
    return ([headers, url]);
} 

export const getProcessingLayerDataWithStatusFromServer = () => {
    let url = baseUrl +  "/recon/get_data_with_status/";
    return ([headers, url]);
} 

export const getUpdateMatchRecordsFromServer = () => {
    let url = baseUrl +  "/recon/get_update_matched_records/";
    return ([headers, url]);
} 

export const getUpdateUnMatchRecordsFromServer = () => {
    let url = baseUrl +  "/recon/get_update_unmatched_records/";
    return ([headers, url]);
} 

export const getUpdateDuplicateRecordsFromServer = () => {
    let url = baseUrl +  "/recon/get_update_duplicate_records/";
    return ([headers, url]);
} 

export const getUpdateContraRecordsFromServer = () => {
    let url = baseUrl +  "/recon/get_update_contra_records/";
    return ([headers, url]);
} 

export const getFileUploadListFromServer = () => {
    let url = baseUrl +  "/recon/get_recon_file_list/";
    return ([headers, url]);
} 

export const getBRSReportFromServer = () => {
    let url = baseUrl +  "/api/v2/user_modules/get_vrs_report/";
    return ([headers, url]);
} 

export const getUpdateGlBalFromServer = () => {
    let url = baseUrl +  "/recon/get_update_gl_balances_revised/";
    return ([headers, url]);
}

export const getUpdateBankBalFromServer = () => {
    let url = baseUrl +  "/recon/get_update_bank_balances_revised/";
    return ([headers, url]);
}

export const getBalanceFromServer = () => {
    let url = baseUrl +  "/recon/get_balances/";
    return ([headers, url]);
}

export const getMonthEndBalanceFromServer = () => {
    let url = baseUrl +  "/recon/get_month_end_balance/";
    return ([headers, url]);
}

export const getUpdateMonthEndBalanceToServer = () => {
    let url = baseUrl +  "/recon/get_update_month_end_balance/";
    return ([headers, url]);
}

export const getUpdateEditedBankStatementToServer = () => {
    let url = baseUrl +  "/recon/get_edit_bank_statement/";
    return ([headers, url]);
}

export const getRunFileFromServer = () => {
    let url = baseUrl + "/recon_etl/get_run_etl/";
    return ([headers, url]);
}

// export const Fetchbankinvoicedetails = () => {
//     let url = baseUrl +  "/api/v2/user_modules/getbankinvoicedetails/";
//     return ([headers, url]);
// }

export const Fetchbankinvoicedetails = () => {
    let url = baseUrl +  "/api/v2/user_modules/getdynamicfilteredlist/VendorReconcilationSystem/vendor_statement/";
    return ([headers, url]);
}

export const Fetchbankinvoicedetails_1 = () => {
    let url = baseUrl +  "/api/v2/user_modules/getdynamicfilteredlist/Vendor_Reconcilation_System/internal_statement/";
    return ([headers, url]);
}

export const Fetchexecutequery = () => {
    let url = baseUrl +  "/api/v2/user_modules/getexecutequery/";
    return ([headers, url]);
}

export const Fetchexecuteclquery = () => {
    let url = baseUrl +  "/api/v2/user_modules/getexecuteclquery/";
    return ([headers, url]);
}

export const FetchUploadGl = () => {
    let url = baseUrl +  "/api/v2/user_modules/uploadgl/";
    return ([headers, url]);
}

export const FetchsavePoRows = () => {
    let url = baseUrl +  "/api/v2/user_modules/getsaveporows/";
    return ([headers, url]);
}


export const FetchsavePIRows = () => {
    let url = baseUrl +  "/api/v2/user_modules/getsavepirows/";
    return ([headers, url]);
}

export const Fetchfileupload = () => {
    let url = baseUrl +  "/api/v2/user_modules/dynamicfileupload1/";
    return ([headers, url]);
}

export const Fetchfileupload_1 = () => {
    let url = baseUrl +  "/api/v2/user_modules/dynamicfileupload2/";
    return ([headers, url]);
}

export const TriggerMail = () => {
    let url = baseUrl +  "/api/v2/user_modules/openmail/";
    return ([headers, url]);
}

export const Fetchfileupload1 = () => {
    let url = baseUrl +  "/api/v2/user_modules/dynamicfileupload/";
    return ([headers, url]);
}

export const Fetchetlupload = () => {
    let url = baseUrl +  "/api/v2/user_modules/dynamicetlupload/";
    return ([headers, url]);
}

export const FetchReadfile = () => {
    let url = baseUrl +  "/api/v2/user_modules/process_files/";
    return ([headers, url]);
}

export const FetchReadmail = () => {
    let url = baseUrl +  "/api/v2/user_modules/process_mails/";
    return ([headers, url]);
}


export const Fetchupdatequery = () => {
    let url = baseUrl +  "/api/v2/user_modules/getdynamicupdatedata/";
    return ([headers, url]);
}
export const Fetchdataprocess = () => {
    let url = baseUrl +  "/api/v2/user_modules/data_process/";
    return ([headers, url]);
}


export const Fetcherpdata_1 = () => {
    let url = baseUrl +  "/api/v2/user_modules/getdynamicfilteredlist/BRS/erp_statement/";
    return ([headers, url]);
}

export const Fetchbankdata_1 = () => {
    let url = baseUrl +  "/api/v2/user_modules/getdynamicfilteredlist/BRS/test1/";
    return ([headers, url]);
}


export const Fetcherpdata = () => {
    let url = baseUrl +  "/api/v2/user_modules/get_all_data/BRS/erp_statement/";
    return ([headers, url]);
}

export const Fetchbankdata = () => {
    let url = baseUrl +  "/api/v2/user_modules/get_all_data/BRS/hdfc_bank/";
    return ([headers, url]);
}


export const Fetchextdetails = () => {
    let url = baseUrl +  "/api/v2/user_modules/getdynamicfilteredlist/account_receivable/ext_bank_2/";
    return ([headers, url]);
}


export const Fetchbankinvoicedetails12 = () => {
    let url = baseUrl +  "/api/v2/user_modules/getdynamicfilteredlist/Vendor_Reconcilation_System/internal_statement/";
    return ([headers, url]);
}

export const Fetchbankinvoicedetails1 = () => {
    let url = baseUrl +  "/api/v2/user_modules/getdynamicfilteredlist/BRS/erp_statement/";
    return ([headers, url]);
}

export const Fetchselectivebankinvoicedetails = () => {
    let url = baseUrl +  "/api/v2/user_modules/getselectivefilteredlist/Vendor_Reconcilation_System/vendor_statement/";
    return ([headers, url]);
}

export const Fetchexternaldetails1 = () => {
    let url = baseUrl +  "/api/v2/user_modules/getdynamicfilteredlist/Vendor_Reconcilation_System/vendor_statement/";
    return ([headers, url]);
}

export const Fetchexternaldetails = () => {
    let url = baseUrl +  "/api/v2/user_modules/getdynamicfilteredlist/BRS/test2/";
    return ([headers, url]);
}



export const Fetchmatchedutrdata = () => {
    let url = baseUrl +  "/api/v2/user_modules/fetchmatchedinternalstmnt/";
    return ([headers, url]);
}

export const Fetchmatchedutrdata1 = () => {
    let url = baseUrl +  "/api/v2/user_modules/fetchmatcheddataall/";
    return ([headers, url]);
}

export const updatedonutvalue = () => {
    let url = baseUrl +  "/api/v2/user_modules/dynamicdonutcountgeneratorpocView/";
    return ([headers, url]);
}


export const updatestatusvalue = () => {
    let url = baseUrl +  "/api/v2/user_modules/updatestatus/";
    return ([headers, url]);
}

export const updateclosurestatusvalue = () => {
    let url = baseUrl +  "/api/v2/user_modules/getdynamicupdatedata/";
    return ([headers, url]);
}

export const allocateupdatestatusvalue = () => {
    let url = baseUrl +  "/api/v2/user_modules/allocateupdatestatus/";
    return ([headers, url]);
}

export const updatestatusvalue1 = () => {
    let url = baseUrl +  "/api/v2/user_modules/updatestatus1/";
    return ([headers, url]);
}

export const fetchmonthwisedata1 = () => {
    let url = baseUrl +  "/api/v2/user_modules/fetchmonthwisedata/";
    return ([headers, url]);
}

export const getdonutseriesdata = () => {
    let url = baseUrl +  "/api/v2/user_modules/fetchdonutchartdata/";
    return ([headers, url]);
}

export const getdonutseriesdata1 = () => {
    let url = baseUrl +  "/api/v2/user_modules/api/getdynamicfilteredlist/Vendor_Reconcilation_System/internal_statement/";
    return ([headers, url]);
}

export const getkpidatafin = () => {
    let url = baseUrl +  "/api/v2/user_modules/generatefindashboard/";
    return ([headers, url]);
}

export const getkpidata = () => {
    let url = baseUrl +  "/api/v2/user_modules/generatekpiinfo/";
    return ([headers, url]);
}

export const getkpidata1 = () => {
    let url = baseUrl +  "/api/v2/user_modules/generatekpiinfo1/";
    return ([headers, url]);
}

export const getkpidata9 = () => {
    let url = baseUrl +  "/api/v2/user_modules/generatekpiinfo3/";
    return ([headers, url]);
}

export const getvendorcode = () => {
    let url = baseUrl +  "/api/v2/user_modules/get_all_data/process_data/process/";
    return ([headers, url]);
}


export const getkpidatarecon = () => {
    let url = baseUrl +  "/api/v2/user_modules/generatekpiinfonew/";
    return ([headers, url]);
}

export const getpaymenthistory = () => {
    let url = baseUrl +  "/api/v2/user_modules/fetchpaymenthistory/";
    return ([headers, url]);
}

export const getstatustypeslist = () => {
    let url = baseUrl +  "/api/v2/user_modules/fetchstatustypeslist/";
    return ([headers, url]);
}

export const getremarksdata = () => {
    let url = baseUrl +  "/api/v2/user_modules/getdynamicfilteredlist/BRS/erp_statement/";
    return ([headers, url]);
}


export const getAgingDashboard = () => {
    let url = baseUrl +  "/api/v2/user_modules/generateagingdashboard/";
    return ([headers, url]);
}

// export const getmodeldata = () => {
//     let url = baseUrl +  "/api/v2/user_modules/fetchagingdataall/";
//     return ([headers, url]);
// }

export const getkpidata3 = () => {
    let url = baseUrl +  "/api/v2/user_modules/fetchagingdataall/";
    return ([headers, url]);
}

export const getkpidata4 = () => {
    let url = baseUrl +  "/api/v2/user_modules/fetchupcommingcollections/";
    return ([headers, url]);
}

export const getexceptiondata = () => {
    let url = baseUrl +  "/api/v2/user_modules/fetchexceptiontypedata/";
    return ([headers, url]);
}

export const getexceptiondata1 = () => {
    let url = baseUrl +  "/api/v2/user_modules/fetchdataforcordsdashboard/";
    return ([headers, url]);
}

export const getexceptiondata2 = () => {
    let url = baseUrl +  "/api/v2/user_modules/fetchdataforcordsfin/";
    return ([headers, url]);
}

export const getdataforcardsrecon = () => {
    let url = baseUrl +  "/api/v2/user_modules/fetchdataforcordsRecon/";
    return ([headers, url]);
}

export const fetchmonthwisedatanew = () => {
    let url = baseUrl +  "/api/v2/user_modules/fetchmonthwisedataall/";
    return ([headers, url]);
}


export const getpaymenthistorynew = () => {
    let url = baseUrl +  "/api/v2/user_modules/fetchpaymenthistoryall/";
    return ([headers, url]);
}


export const getdashboard1sidement = () => {
    let url = baseUrl +  "/api/v2/user_modules/dashboard1sidemenulist/";
    return ([headers, url]);
}